import React from "react";
import {IhioWrittenPrescriptionItemType} from "../../../../../types/ihioPrescriptionFilling";
import Tooltip from "../../../general/tooltip";
import Icon from "../../../general/icon";
import Alert from "../../../general/alert";

type ReadyToFulfilPrescriptionCardProps = {
    item: IhioWrittenPrescriptionItemType
}

const ReadyToFulfilPrescriptionCard = ({
   item,
}: ReadyToFulfilPrescriptionCardProps) => {

    return (
        <div className={`card shadow-none border rounded-4 my-3`}>
            <div className={'card-body'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div className={'d-flex align-items-center gap-3'}>
                        <div>
                            {item?.itemsToBeDelivered || 0} عدد
                        </div>
                    </div>
                    <bdi className={'d-flex align-items-center gap-3'}>
                        <div
                            className={'badge badge-primary px-2 py-2'}
                        >
                            {item?.irc || ''}
                        </div>
                        <bdi>
                            {item?.name}
                        </bdi>
                        {item?.message?.info && item?.message?.info?.map((message: string) => {
                            return (
                                <Tooltip alt={message}>
                                    <span className={'font-20 text-purple'}>
                                        <Icon name={'info-circle'}/>
                                    </span>
                                </Tooltip>
                            )
                        })}
                        {item?.message?.warning && item?.message?.warning?.map((message: string) => {
                            return (
                                <Tooltip alt={message}>
                                    <span className={'font-20 text-yellow'}>
                                        <Icon name={'info-circle'}/>
                                    </span>
                                </Tooltip>
                            )
                        })}
                    </bdi>
                </div>
                <div className={'row row-cols-md-4 row-cols-2 mt-3'}>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            فیمت واحد:
                        </span>
                        <span className={''}>
                            {item?.priceInfo?.tariffInfo?.basePrice || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            مبلغ کل:
                        </span>
                        <span className={''}>
                            {item?.priceInfo?.calculated?.total || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            پرداختی بیمار:
                        </span>
                        <span className={''}>
                            {item?.priceInfo?.calculated?.insuredAmount || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            سهم سازمان:
                        </span>
                        <span className={''}>
                            {item?.priceInfo?.calculated?.orgAmount || 0}
                        </span>
                    </div>
                </div>
                {item?.description && (
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            توضیحات:
                        </span>
                        <span className={''}>
                            {item?.description}
                        </span>
                    </div>
                )}
                {
                    item?.message?.error?.map((item: string) => {
                        return (
                            <div className='mt-3'>
                                <Alert
                                    className={'border-dashed border-warning border-2'}
                                    type={'warning'}
                                    text={item}
                                    icon={'info-circle'}
                                />
                            </div>
                        );
                    })
                }
            </div>
        </div>
    )
}


export default ReadyToFulfilPrescriptionCard;